import { Resource } from '../../../http/resource/resource.model';
// tslint:disable: variable-name

export class ProcessSelection extends Resource {
  logo: string;
  institutional_color: string;
  favicon: string;
  background: string;
  selectiveProcesses: Array<any>;
  name: string;
  title: string;
}
